define('entities/lmbanalyzers',[
  'app',
  'backbone',
  'settings',
  'jquery',
  'underscore'
], function(
  App,
  Backbone,
  Settings,
  $,
  _
) {
  'use strict';

  var LmbAnalyzer = Backbone.Model.extend({
    fetch: function() {
      this.url = Settings.url('compuzz', 'v2/lmbanalyzers/' + this.get('secId'));

      return Backbone.Model.prototype.fetch.call(this);
    },
    defaults: {
      code: '',
      serialNb: '',
      location: '',
      description: ''
    },
    idAttribute: 'secId',
    getImageUid:function() {},

    postUrl: function () {
      return Settings.url('compuzz', 'v2/lmbanalyzers');
    },

    save: function() {
      this.url = this.postUrl();
      return Backbone.Model.prototype.save.call(this);
    }
  });

  var LmbAnalyzerCollection = Backbone.Collection.extend({
    url: function() {
      return Settings.url('compuzz', 'v2/lmbanalyzers');
    },
    model: LmbAnalyzer
  });

  var API = {

    getLmbAnalyzerCollectionUrl: function() {
      new LmbAnalyzerCollection();
      var params = {};
      return Settings.url('compuzz', 'v2/lmbanalyzers', params);
    },

    getAllLmbAnalyzers: function(params) {
      var url = Settings.url('compuzz', 'v2/lmbanalyzers', params),
          defer = $.Deferred();

      $.ajax({
        method: 'get',
        url: url,
        success: function(items) {
          var list = [];
          _.each(items, function(item){
            list.push(item.secId);
          });
          defer.resolve(list);
        }
      });

      return defer.promise();
    },

    getLmbAnalyzerCountUrl: function() {
      var params = '';
      return 'v2/lmbanalyzers/rowCount' + params;
    },

    deleteLmbAnalyzer: function(secId){
      var url = Settings.url('compuzz', 'v2/lmbanalyzers/'+secId),
          defer = $.Deferred();

      $.ajax({
        type: 'DELETE',
        url: url,
        success: function (data) {
          defer.resolve(data);
        }
      });

      return defer.promise();
    }
  };

  App.reqres.setHandler('lmbanalyzer:get-collection-url', function() {
      return API.getLmbAnalyzerCollectionUrl();
  });

  App.reqres.setHandler('lmbanalyzer:get-collection-to-page', function(params) {
      return API.getAllLmbAnalyzers(params);
  });

  App.reqres.setHandler('lmbanalyzer:get-count-url', function() {
    return API.getLmbAnalyzerCountUrl();
  });

  App.reqres.setHandler('lmbanalyzer:model', function(itemJSON) {
    return new LmbAnalyzer(itemJSON);
  });

  App.reqres.setHandler('lmbanalyzer:delete', function(secId) {
    return API.deleteLmbAnalyzer(secId);
  });
});
